/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import CursoTipoMonedaForm from './CursoTipoMonedaForm';
import * as validations from '../../validations/validations';
import * as cursotipomonedaActions from '../../actions/cursotipomonedaActions';
import * as cursoActions from '../../actions/cursoActions';
import * as tipomonedaActions from '../../actions/tipomonedaActions';
import * as userActions from '../../actions/userActions';
import {  useParams } from "react-router-dom";
import {  useLocation, useNavigate  } from "react-router-dom";
import * as paginaActions from '../../actions/paginaActions';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import { Segment} from 'semantic-ui-react';
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment';
import withRouter from '../common/withRouter';
import {getMargenes, usuarioActual} from '../../util/';
import $ from 'jquery';


class ManageCursoTipoMonedaForm extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            permisos:{},
			cursotipomoneda:{
                    }
		};
		
	}
    
    
    componentDidMount(){
        /*
        let id=this.props.id;
        let pageInfo={ 
            page:'cursotipomoneda', 
            idioma:this.props.idioma     
        }; 
        this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);  
       this.props.paginaActions.getInfo(pageInfo, this.props.user).then( pageInfoResponse=>{ 
           this.setState({"permisos":pageInfoResponse.permisos, 
                         "strings":Object.assign({}, pageInfoResponse.strings)}); 
       }) 
        .catch(error=>{ 
          toastr.error(error); 
        });
        */
        usuarioActual(this, "cursotipomoneda",true).then( (usuario)=>{
        
            let id=this.props.id;
            
            
            this.props.cursoActions.getCursoCombo(usuario).then(()=>{}) 
            .catch(error=>{ 
              toastr.error(error); 
            }); 

            this.props.tipomonedaActions.getTipoMonedaCombo(usuario).then(()=>{}) 
            .catch(error=>{ 
              toastr.error(error); 
            });
        
        
            if(id && id>0 ){

               this.props.cursotipomonedaActions.getCursoTipoMoneda(id, usuario).then( cursotipomoneda=>{
                   this.setState({"cursotipomoneda":cursotipomoneda});
               })
                .catch(error=>{
                  toastr.error(error);
                }); 
            }
        
       
        })
        .catch(error=>{
            toastr.error(error);
        }); 
    }
    

    handleChange=(event, data)=> {

        let cursotipomoneda = this.state.cursotipomoneda;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		cursotipomoneda[field[0]]= value;
		else{
             if(!cursotipomoneda[field[0]]){
                    cursotipomoneda[field[0]]={}
                }
			cursotipomoneda[field[0]][field[1]]= value;
		}
        
		
        this.setState({"cursotipomoneda": cursotipomoneda});
    }
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let cursotipomoneda=this.state.cursotipomoneda;
              
        if(!validations.requerido(cursotipomoneda.idCurso)){
            errors.idCurso=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(cursotipomoneda.idTipoMoneda)){
            errors.idTipoMoneda=true;
            formIsValid=false;
        }
        
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }



    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
       
        
        this.props.cursotipomonedaActions.save(this.state.cursotipomoneda, this.props.user).then(() => {
            toastr.success("Registro guardado!!!.");
            this.props.navigate(-1);
        });
        
    }

       
    render() {	
          
   let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		 		return (
              <Segment  style={margenes}>
                <CursoTipoMonedaForm 
                    strings={this.props.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.cursotipomoneda}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                    cursoCombo={genericFormattedForDropdown(this.props.cursoCombo)}
                    tipomonedaCombo={genericFormattedForDropdown(this.props.tipomonedaCombo)}
                />

            </Segment> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    
        
    return {        
        ajaxCallInProgress:state.ajaxCallInProgress,
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda, 
        color:state.color,
        user:state.user, 
        idioma:state.idioma,
        form:state.form,
        cursoCombo:state.cursoCombo,
        tipomonedaCombo:state.tipomonedaCombo,
        strings:state.strings, 
    }

}

function mapDispatchToProps(dispatch){

	return {   
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        cursotipomonedaActions: bindActionCreators(cursotipomonedaActions, dispatch),
        cursoActions: bindActionCreators(cursoActions, dispatch),
        tipomonedaActions: bindActionCreators(tipomonedaActions, dispatch)
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(withRouter(ManageCursoTipoMonedaForm));